import ApiResourceManager from '../ApiResourceManager';

export default class PaymentGatewaysManager extends ApiResourceManager {
  get = (params) =>
    this.request({
      method: 'GET',
      url: '/companies-payment-gateways',
      params,
    });

  updatePaymentGateway = (companyId, data) =>
    this.request({
      method: 'PUT',
      url: `/companies/${companyId}/payment-gateway`,
      data,
      headers: {
        'x-on-behalf-of-company': companyId,
      },
    });

  getOnboardingLinks = (companyId) =>
    this.request({
      method: 'GET',
      url: `/companies/${companyId}/payment-gateway-onboarding-links`,
    });

  createOnboardingLink = (companyId, data) =>
    this.request({
      method: 'POST',
      url: `/companies/${companyId}/payment-gateway-onboarding-links`,
      data,
    });
}
